export default {
  auth_request(state) {
    state.status = 'loading'
  },
  logout(state) {
    state.status = ''
    state.token = ''
    state.user = {}
  },
  auth_success(state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  auth_error(state) {
    state.status = 'error'
  },
}
